import React from "react";
import "@/App.css";
import { Toaster } from "sonner";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import MarqueeBar from "./components/MarqueeBar";
import About from "./components/About";
import Services from "./components/Services";
import Plans from "./components/Plans";
import Portfolio from "./components/Portfolio";
import Gallery from "./components/Gallery";
import Booking from "./components/Booking";
import Testimonials from "./components/Testimonials";
import FAQ from "./components/FAQ";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App bg-ink text-cream min-h-screen">
      {/* Global SVG filters for brush-stroke effects */}
      <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden>
        <defs>
          <filter id="brushFilter">
            <feTurbulence type="fractalNoise" baseFrequency="0.04 0.08" numOctaves="2" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="9" />
          </filter>
          <filter id="brushSoft">
            <feTurbulence type="fractalNoise" baseFrequency="0.02 0.05" numOctaves="1" result="noise" />
            <feDisplacementMap in="SourceGraphic" in2="noise" scale="4" />
          </filter>
        </defs>
      </svg>
      <Navbar />
      <main>
        <Hero />
        <MarqueeBar />
        <About />
        <Services />
        <Plans />
        <Portfolio />
        <Gallery />
        <Booking />
        <Testimonials />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 9999,
            border: "2px solid #0A0A0A",
            background: "#D4FF3D",
            color: "#0A0A0A",
            fontFamily: "Anton, sans-serif",
            fontSize: "14px",
            fontWeight: 700,
          },
        }}
      />
    </div>
  );
}

export default App;
